$(document).ready(function(){
  $('.hb-text-imgWrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrow: false,
    dots: false,
    fade: true
  });

  $('.hb-media__content').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrow: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.hb-faqSlider__inner').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrow: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrow: true
        }
      }
    ]
  });
});

$(document).ready(function(){
  var row = $('.feature-row__text');
  var rowW = row.width();
  $('.hb-text-imgWrapper').css('max-width', rowW);
});


// ここから旧サイトのコード
async function addToCart(event) {
  const variantId = event.currentTarget.dataset.id;
  const quantity = parseInt(event.currentTarget.dataset.quantity || "1");

  let directlyGoToCheckout = false;
  let __source;
  const url = window.location.href;

  if (url.includes('pages/lp-334-hb2310')) {
    __source = 'lp-chocolate-hb2310';
  } else if (url.includes('pages/lp-120-hb2408')) {
    __source = 'lp-pouch-hb2407';
    directlyGoToCheckout = true;
  } else if (url.includes('pages/lp-265-hb2303')) {
    __source = 'lp-265-hb2303';
  } else {
    console.error('Unsupported URL:', url);
    return;
  }

  const attributes = { __source };
  const properties = { __source };
  const formData = {
    attributes,
    items: [
      {
        id: variantId,
        quantity,
        properties
      }
    ]
  };

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.location.href = directlyGoToCheckout ? "/cart/checkout" : "/cart/";
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

const allButtons = document.querySelectorAll('[data-id]');
allButtons.forEach(button => {
  button.addEventListener('click', addToCart);
});


